import { ShareResult, ShareResultError, ShareResultErrorWithEmail, ShareResultTuple } from '../..';

export class SharingResult {
  constructor(
    private readonly domain: { add?: ShareResult; remove?: ShareResult },
    private readonly groups: {
      add: Record<string, ShareResult>;
      remove: Record<string, ShareResult>;
    },
    private readonly publicAccess: { add?: ShareResult; remove?: ShareResult },
    private readonly users: {
      add: Record<string, ShareResult>;
      remove: Record<string, ShareResult>;
    },
  ) {}

  public getDomainAddError(): ShareResultError | undefined {
    return this.domain.add?.success === false ? this.domain.add : undefined;
  }

  public getDomainRemoveError(): ShareResultError | undefined {
    return this.domain.remove?.success === false ? this.domain.remove : undefined;
  }

  public getTeamGroupsAddErrors(): ShareResultErrorWithEmail[] {
    return Object.entries(this.groups.add)
      .filter((result): result is ShareResultTuple<ShareResultError> => !result[1].success)
      .map((result) => ({ email: result[0], ...result[1] }));
  }

  public getTeamGroupsRemoveErrors(): ShareResultErrorWithEmail[] {
    return Object.entries(this.groups.remove)
      .filter((result): result is ShareResultTuple<ShareResultError> => !result[1].success)
      .map((result) => ({ email: result[0], ...result[1] }));
  }

  public getPublicAccessAddError(): ShareResultError | undefined {
    return this.publicAccess.add?.success === false ? this.publicAccess.add : undefined;
  }

  public getPublicAccessRemoveError(): ShareResultError | undefined {
    return this.publicAccess.remove?.success === false ? this.publicAccess.remove : undefined;
  }

  public getUsersAddErrors(): ShareResultErrorWithEmail[] {
    return Object.entries(this.users.add)
      .filter((result): result is ShareResultTuple<ShareResultError> => !result[1].success)
      .map((result) => ({ email: result[0], ...result[1] }));
  }

  public getUsersRemoveErrors(): ShareResultErrorWithEmail[] {
    return Object.entries(this.users.remove)
      .filter((result): result is ShareResultTuple<ShareResultError> => !result[1].success)
      .map((result) => ({ email: result[0], ...result[1] }));
  }

  public hasErrors(): boolean {
    return (
      this.hasDomainAddError() ||
      this.hasDomainRemoveError() ||
      this.hasTeamGroupsAddErrors() ||
      this.hasTeamGroupsRemoveErrors() ||
      this.hasPublicAccessAddError() ||
      this.hasPublicAccessRemoveError() ||
      this.hasUsersAddErrors() ||
      this.hasUsersRemoveErrors()
    );
  }

  public hasPublicAccessAddError(): boolean {
    return this.publicAccess.add?.success === false;
  }

  public hasPublicAccessRemoveError(): boolean {
    return this.publicAccess.remove?.success === false;
  }

  public hasDomainAddError(): boolean {
    return this.domain.add?.success === false;
  }

  public hasDomainRemoveError(): boolean {
    return this.domain.remove?.success === false;
  }

  public hasTeamGroupsAddErrors(): boolean {
    return Object.values(this.groups.add).some((result) => !result.success);
  }

  public hasUsersAddErrors(): boolean {
    return Object.values(this.users.add).some((result) => !result.success);
  }

  public hasTeamGroupsRemoveErrors(): boolean {
    return Object.values(this.groups.remove).some((result) => !result.success);
  }

  public hasUsersRemoveErrors(): boolean {
    return Object.values(this.users.remove).some((result) => !result.success);
  }
}
